/* eslint-disable no-param-reassign */
export default ['$scope', '$uibModalInstance', 'deviceService', 'options',
  // eslint-disable-next-line func-names
  function ($scope, $uibModalInstance, deviceService, options) {
    $scope.isMobile = deviceService.isMobile;

    $scope.getImagePreviewUrl = () => {
      return options.imageUrl;
    };

    $scope.close = () => {
      $uibModalInstance.close();
    };
  },
];
